import {Pipe} from "@angular/core";
import {KompaktdarstellungPipe} from "../kompakt-darstellung.pipe";
import {FormatConfigService} from "../../../core/services/format-config.service";
import {PlatformLocation} from "@angular/common";
import {ComponentLocationStrategy} from "../../services/location-strategy/component-location-strategy";
import {GebaeudeEingangAdresseListEntry} from "../../../core/av-api";

@Pipe({
  name: 'kompaktGebaeudeeingangsadresse'
})
export class KompaktGebaeudeeingangsadressePipe extends KompaktdarstellungPipe<GebaeudeEingangAdresseListEntry> {

  constructor(protected formatConfigService: FormatConfigService, protected location: PlatformLocation,
              protected kompaktLocation: ComponentLocationStrategy) {
    super(formatConfigService, 'GEBAEUDEEINGANGSADRESSE', location, kompaktLocation);
  }

  transform(adresse: GebaeudeEingangAdresseListEntry): string {
    if (!adresse) {
      return '';
    }
    if (this.formatElement === 'GEBAEUDEEINGANGSADRESSE_TYP00') {
      return this.getDefaultFormat(adresse);
    }
    // ...
    return this.getDefaultFormat(adresse);
  }

  getDefaultFormat(adresse: GebaeudeEingangAdresseListEntry) {
    const strasseHausnummer = [adresse.strasse, adresse.hausnummer].filter(val => val).join(' ');
    const ortschaft = [adresse.plz, adresse.ortschaft].filter(val => val).join(' ');
    const result = [strasseHausnummer, ortschaft].filter(val => val).join(', ');
    return result;
  }

}
